import { GlobalLoading } from "@caju-beneficios/react-web-commons";
import { SV2UserContext } from "@caju-beneficios/sponsor-v2-lib";
import { AuthManager } from "@caju-beneficios/sponsor-v2-lib/dist/lib/auth";
import React from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import { RedirectToLogin } from "./components/environment/redirectToLogin";
import { PrivateRoutes } from "./pages/private";
import { LoginPage } from "./pages/public/login";

export function AppContent() {
  const userContext = React.useContext(SV2UserContext);
  const hasAuthInfo = !!AuthManager.getAuthInfo();

  if (userContext.loading)
    return (
      <React.Fragment>
        <GlobalLoading show message="Carregando..." />
      </React.Fragment>
    );

  return (
    <HashRouter>
      <Switch>
        <Route path={"/login"} component={LoginPage} />

        {userContext.user && <PrivateRoutes />}

        {!userContext.user && !hasAuthInfo && <RedirectToLogin />}
      </Switch>
    </HashRouter>
  );
}
